import { Component, viewChild, ChangeDetectionStrategy } from '@angular/core';

import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSidenav } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { DATETIME_FORMATS } from 'src/@types/dateformats';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [provideMomentDateAdapter(DATETIME_FORMATS)],
})
export class AppComponent {
    readonly sidenav = viewChild<MatSidenav>('sidenav');
    isExpanded = true;
    showSubmenu = false;
    isShowing = false;
    showSubSubMenu = false;
    menu = [{ item: 'Hydra V1', submenu: null, href: '/' }];

    toolbarEvent(_event: any) {
        let side = this.sidenav();
        if (side) side.toggle();
    }

    title = 'hydra-v2';
}
